import React from 'react';
import { Link } from 'react-router-dom';

const ProfileHero = ({ user, metrics, loading }) => {
  const displayName = user?.user_metadata?.full_name || user?.email?.split('@')?.[0] || 'Bruker';
  const initial = displayName?.[0]?.toUpperCase() || 'B';
  const email = user?.email || '';

  return (
    <div style={{
      position: 'relative',
      background: 'linear-gradient(135deg, #0D1929 0%, #1A2E52 50%, #0D1929 100%)',
      overflow: 'hidden',
      padding: '48px 0 40px',
      marginBottom: '48px',
    }}>
      {/* Norwegian landscape silhouette */}
      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '120px', opacity: 0.12 }}>
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none" style={{ width: '100%', height: '100%' }}>
          <path d="M0 80 L80 40 L160 60 L240 20 L320 50 L400 10 L480 45 L560 25 L640 55 L720 15 L800 50 L880 30 L960 60 L1040 20 L1120 45 L1200 35 L1200 120 L0 120 Z" fill="#3B6FD4" />
        </svg>
      </div>
      {/* Aurora streaks */}
      <div style={{ position: 'absolute', top: '20px', left: 0, right: 0, height: '2px', background: 'linear-gradient(90deg, transparent, #2EC4A044, #3B6FD444, transparent)', transform: 'rotate(-1deg)' }} />
      <div style={{ position: 'absolute', top: '32px', left: 0, right: 0, height: '1px', background: 'linear-gradient(90deg, transparent, #6B5CE722, transparent)', transform: 'rotate(0.5deg)' }} />
      {/* Ghost text */}
      <div style={{ position: 'absolute', top: '-20px', right: '-20px', fontFamily: 'Impact, sans-serif', fontSize: '10rem', color: 'rgba(59,111,212,0.05)', lineHeight: 1, userSelect: 'none', pointerEvents: 'none', letterSpacing: '-0.05em' }}>PROFIL</div>
      <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '0 24px', position: 'relative', zIndex: 1 }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '28px', flexWrap: 'wrap' }}>
          {/* Avatar */}
          <div style={{
            width: '80px', height: '80px', flexShrink: 0,
            background: 'linear-gradient(135deg, #3B6FD4, #6B5CE7)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            clipPath: 'polygon(0 0, calc(100% - 10px) 0, 100% 10px, 100% 100%, 10px 100%, 0 calc(100% - 10px))',
            border: '2px solid rgba(59,111,212,0.4)',
          }}>
            <span style={{ fontFamily: 'Impact, sans-serif', fontSize: '2.5rem', color: '#EEF0F2' }}>{initial}</span>
          </div>

          {/* User info */}
          <div style={{ flex: 1, minWidth: '200px' }}>
            <div style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.6rem', color: '#3B6FD4', letterSpacing: '0.2em', textTransform: 'uppercase', marginBottom: '6px' }}>BRUKERPROFIL</div>
            <h1 style={{ fontFamily: 'Impact, sans-serif', fontSize: '2.2rem', color: '#EEF0F2', letterSpacing: '0.02em', transform: 'rotate(-0.5deg)', margin: '0 0 4px 0', lineHeight: 1 }}>
              {displayName?.toUpperCase()}
            </h1>
            <div style={{ fontFamily: 'Georgia, serif', fontSize: '0.85rem', color: 'rgba(238,240,242,0.5)', fontStyle: 'italic', marginBottom: '12px' }}>{email}</div>

            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              <Link
                to="/nord-pass-subscription-portal"
                style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.6rem', color: '#2EC4A0', border: '1px solid #2EC4A044', padding: '4px 12px', textDecoration: 'none', letterSpacing: '0.1em', transition: 'all 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.background = '#2EC4A011'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                → MIN KONTO
              </Link>
              <Link
                to="/blog-news-landing-page-blogg-nyheter"
                style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.6rem', color: '#3B6FD4', border: '1px solid #3B6FD444', padding: '4px 12px', textDecoration: 'none', letterSpacing: '0.1em', transition: 'all 0.2s' }}
                onMouseEnter={e => e.currentTarget.style.background = '#3B6FD411'}
                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
              >
                → BLOGG
              </Link>
            </div>
          </div>

          {/* Quick stats */}
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', alignSelf: 'center' }}>
            {[
              { label: 'KOMMENTARER', value: metrics?.totalComments ?? '—', color: '#3B6FD4' },
              { label: 'LIKES', value: metrics?.totalLikes ?? '—', color: '#E76F51' },
              { label: 'SVAR', value: metrics?.totalReplies ?? '—', color: '#2EC4A0' },
            ]?.map((stat, i) => (
              <div key={i} style={{ textAlign: 'center', background: 'rgba(255,255,255,0.04)', border: `1px solid ${stat?.color}33`, padding: '12px 20px', minWidth: '80px' }}>
                {loading ? (
                  <div style={{ height: '32px', background: 'rgba(255,255,255,0.06)' }} />
                ) : (
                  <div style={{ fontFamily: 'Impact, sans-serif', fontSize: '1.8rem', color: stat?.color, lineHeight: 1 }}>{stat?.value}</div>
                )}
                <div style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.5rem', color: 'rgba(238,240,242,0.4)', letterSpacing: '0.1em', marginTop: '4px' }}>{stat?.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHero;
